import { Button, Grid, Stack } from '@mui/material';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTab } from 'src/components/hooks/useTab';
import { useGetSysAdminNewCodelistQuery } from 'src/services/workarea';
import { AppState } from 'src/store';
import { setConfirmExitPopupVal } from 'src/store/confirmPopupVal';
import SiteDocuments from './SiteDocuments';

const SiteDocumentsPage: React.FunctionComponent<any> = () => {
  const { setTabVal, tabVal, tabsData } = useTab();
  const currentTabinfo: any = tabsData.filter((item: any) => item.index === tabVal);
  const dispatch = useDispatch();
  const docNameCodeListValue = 'SUSDCSC';
  const docSecCodeListValue = 'SUSDCNM';
  const { data: docNameData } = useGetSysAdminNewCodelistQuery(docNameCodeListValue);
  const { data: docSecData } = useGetSysAdminNewCodelistQuery(docSecCodeListValue);

  const confirmexitpopupval: any = useSelector((state: AppState) => state.confirmexitpopupval);
  const handleNextbtn = (_: any) => {
    const popupShowed = localStorage.getItem('popupShowed');
    if (popupShowed === 'true' && confirmexitpopupval.confirmexitpopupval === true) {
      setConfirmExitPopupVal(dispatch, false);
      setConfirmExitPopupVal(dispatch, true);
    }
    setTabVal(tabVal + 1);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="pi-accordion lastAccordionSetting">
      <SiteDocuments DocNameData={docNameData} DocSecData={docSecData} />
      {currentTabinfo[0]?.NextButton && (
        <Grid container spacing={2} className="bottom-navigation">
          <Grid item md={12} display="flex" justifyContent="flex-end">
            <Stack spacing={2} direction="row">
              <Button variant="contained" onClick={handleNextbtn}>
                NEXT
              </Button>
            </Stack>
          </Grid>
        </Grid>
      )}
    </div>
  );
};

export default SiteDocumentsPage;
